import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { selectV2Theme } from "../selectV2Theme";
var shouldForwardProp = function shouldForwardProp(propName) {
  switch (propName) {
    case "height":
    case "isVirtualized":
    case "themeMode":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
export var OptionBaseStyled = styled("div", {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border-radius: ", ";\n    cursor: pointer;\n    height: auto;\n    line-height: 18px;\n    margin: ", ";\n    min-height: ", "px;\n    overflow: hidden;\n    padding: ", ";\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n\n    background-color: ", ";\n    color: ", ";\n    transition: background-color ", ";\n    > * {\n        font-size: ", ";\n        white-space: normal;\n        font-weight: 500;\n    }\n\n    // For situations like using a isReadOnly Ratings component as the option\n    // we still want to show the pointer cursor, even though Ratings itself would show a default cursor\n    * {\n        cursor: pointer;\n    }\n\n    &[data-highlighted=\"true\"] {\n        color: ", ";\n        background-color: ", ";\n    }\n\n    &:not([aria-disabled=\"true\"]):active {\n        background-color: ", ";\n    }\n\n    &[aria-disabled=\"true\"] {\n        color: ", ";\n        background-color: transparent;\n        > * {\n            cursor: not-allowed;\n        }\n    }\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return menuTheme.borderRadius(themeMode);
}, function (_ref2) {
  var isVirtualized = _ref2.isVirtualized;
  return isVirtualized ? "0" : "0 4px";
}, function (_ref3) {
  var height = _ref3.height;
  return height;
}, function (_ref4) {
  var themeMode = _ref4.themeMode;
  return selectV2Theme.padding(themeMode);
}, function (_ref5) {
  var themeMode = _ref5.themeMode;
  return menuTheme.backgroundColor.rest(themeMode);
}, function (_ref6) {
  var themeMode = _ref6.themeMode;
  return menuTheme.fontColor.rest(themeMode);
}, motion.animation.default, function (_ref7) {
  var themeMode = _ref7.themeMode;
  return menuTheme.fontSize(themeMode);
}, function (_ref8) {
  var themeMode = _ref8.themeMode;
  return menuTheme.fontColor.focus(themeMode);
}, function (_ref9) {
  var themeMode = _ref9.themeMode;
  return selectV2Theme.option.backgroundColor.hover(themeMode);
}, function (_ref10) {
  var themeMode = _ref10.themeMode;
  return selectV2Theme.option.backgroundColor.active(themeMode);
}, function (_ref11) {
  var themeMode = _ref11.themeMode;
  return menuTheme.fontColor.disabled(themeMode);
});
//# sourceMappingURL=OptionBaseStyled.js.map